import { createApiAction } from '@app/packages/api/utils'
import type { V3GetPromocodesByCodeParams } from '@app/packages/api/v3/types/params'
import type { V3GetPromocodesByCodeResponse } from '@app/packages/api/v3/types/responses'

/** Public. Looked up as typed, then normalized, as applying it would. Rate limited per IP: 30 a minute. */
export const getPromocodesByCode = (code: string, { region_id, training_format }: V3GetPromocodesByCodeParams = {}) =>
  createApiAction('getPromocodesByCode', dispatch =>
    dispatch<V3GetPromocodesByCodeResponse>({
      endpoint: `/api/v3/promocodes/${encodeURIComponent(code)}${buildQuery({ region_id, training_format })}`,
      method: 'GET',
    })
  )

const buildQuery = (params: Record<string, string | undefined>): string => {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) if (value !== undefined) search.set(key, value)
  const query = search.toString()
  return query ? `?${query}` : ''
}
